import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  HeaderArea,
  HeaderTitle,
  ManageSubCard,
  ManageSubDetails,
} from 'src/components';
import { useCurrentUser } from 'src/hooks';

export const ManageSub = () => {
  const { user } = useCurrentUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // redirect user to org-settings page if they are not an admin in the org
  if (
    user?.subscription.tier === 'organization' &&
    user?.subscription.role !== 'admin'
  ) {
    navigate('/plus/your-org');
  }

  return (
    <div className='flex w-full flex-col items-center justify-center gap-6'>
      <HeaderArea>
        <HeaderTitle title={t('common.manage_subscription')} />
      </HeaderArea>
      <div className='flex w-full max-w-[760px] flex-col items-center justify-center gap-8 bg-offWhite px-4 py-8 sm:gap-10 sm:px-8 sm:py-12 md:gap-10 md:px-12 md:py-16 lg:gap-12'>
        <ManageSubCard subTier={user?.subscription.tier || 'free'} />
        <div className='flex w-full flex-col items-start justify-center gap-6 md:gap-8'>
          <ManageSubDetails subTier={user?.subscription.tier || 'free'} />
        </div>
      </div>
    </div>
  );
};
